var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:_vm.name,staticClass:"centered-input",attrs:{"hide-details":"","dense":"","outlined":"","readonly":"","disabled":"","label":_vm.label,"placeholder":_vm.label,"value":_vm.newValue}})}
var staticRenderFns = []

export { render, staticRenderFns }